import { Stack, useTheme } from '@mui/material'
import { FC } from 'react'
import { Outlet } from 'react-router-dom'

export const NestedNavigationLayout: FC = ({ children }) => {
  const {
    palette: {
      background: { paper },
      divider,
    },
  } = useTheme()

  return (
    <Stack direction="row" flex={1}>
      {!!children && (
        <Stack
          width={210}
          sx={{ backgroundColor: paper, borderRight: `solid 0.5px ${divider}` }}
          zIndex={1}
        >
          {children}
        </Stack>
      )}
      <Stack flex={1} zIndex={0}>
        <Outlet />
      </Stack>
    </Stack>
  )
}
